import axios from "axios"
import { setToast } from "../store/actions/configActions"
import { saveShippingList } from "../store/actions/shippingActions"
import { validateRate, validateString } from "../helper"

export const getRates = async shop_id => {
    try {
        const config = {
            method: 'GET',
            url: `/shipping`,
            headers: { shop_id, "x-access-token": shop_id }
        }
        return (await axios.request(config)).data
    } catch (e) {
        return e.message
    }
}
export const countRates = async shop_id => {
    try {
        const config = {
            method: 'GET',
            url: `/shipping/count`,
            headers: { shop_id, "x-access-token": shop_id }
        }
        return (await axios.request(config)).data
    } catch (e) {
        return e.message
    }
}

export const saveRate = async (Rate, rateId, ratesPermission, checkout_ui, exceptions, conditions, loading, dispatch, DeletedRanges, setErrors, navigate, showToast, fetchJson) => {
    const toast = { active: true, error: true, content: '' }
    if (ratesPermission) {
        if (window.navigator.onLine) {
            const error = "Required*"
            // let errors = {};
            // let isError = false

            let { errors, isError } = validateRate(Rate, checkout_ui, toast)

            // for (const key in Rate) {
            //     if (key === "shipping_by" && (Rate[key] === "city" || Rate[key] === "zip" || Rate[key] === "state" || Rate[key] === "countries")) {
            //         if (Rate[key] === "zip" && (!Rate.zip_codes || Rate.zip_codes.length === 0)) {
            //             isError = true;
            //             errors.zip_codes = error
            //         } else if (Rate[key] === "city" && (!Rate.cities || Rate.cities.length === 0)) {
            //             isError = true
            //             errors.cities = error
            //         } else if (Rate[key] === "state" && (!Rate.states || Rate.states.length === 0)) {
            //             isError = true
            //             errors.states = error
            //         } else if (Rate[key] === "countries" && (!Rate.countries || Rate.countries.length === 0)) {
            //             isError = true
            //             errors.countries = error
            //         }
            //     } else if ((key === "display_name" || key === "default_cost") && (Rate[key] === null || Rate[key].trim() === "")) {
            //         isError = true
            //         errors[key] = error
            //     } else if (key === "description" && Rate[key] && Rate[key].length > 255) {
            //         isError = true
            //         errors[key] = "Maximum 255 charcters allowed"
            //     } else if (key === "charge_by" && Rate[key] !== 'no' && Rate.shipping_ranges.length === 0) {
            //         toast.content = 'Atleast one range is required.'
            //         isError = true
            //     } else if (checkout_ui && key === "delivery") {
            //         let message = validateString(Rate[key])
            //         errors[key] = message
            //         isError = message !== ""
            //     }
            // }
            const { shipping_ranges, charge_by } = Rate
            if (shipping_ranges?.length > 0 && charge_by !== "no") {
                for (const i in shipping_ranges) {
                    if (shipping_ranges[i].cost === "" && shipping_ranges[i].from === "" && shipping_ranges[i].upto === "") {
                        isError = true
                        errors[i] = { from: error, upto: error, cost: error }
                    }
                    else if (shipping_ranges[i].cost === "" && (shipping_ranges[i].from !== "" || shipping_ranges[i].upto !== "")) {
                        isError = true
                        errors[i] = { from: '', upto: '', cost: error }
                    }
                    else if (shipping_ranges[i].cost !== "" && shipping_ranges[i].from === "" && shipping_ranges[i].upto === "") {
                        isError = true
                        errors[i] = { from: error, upto: error, cost: '' }
                    }
                }
            } else {
                Rate.shipping_ranges = []
            }
            setErrors({ ...errors })
            if (!isError) {
                let data = { ...Rate }
                if (exceptions) {
                    if (!exceptions.includes("zip")) {
                        data.exp_zip_codes = null
                    }
                    if (!exceptions.includes("city")) {
                        data.exp_cities = null
                    }
                    if (!exceptions.includes("state")) {
                        data.exp_states = null
                    }
                } else {
                    data.exp_zip_codes = null
                    data.exp_cities = null
                    data.exp_states = null
                }

                if (data.shipping_by === 'zip') {
                    data.cities = data.states = data.countries = null
                } else if (data.shipping_by === 'city') {
                    data.zip_codes = data.states = data.countries = null
                } else if (data.shipping_by === 'state') {
                    data.zip_codes = data.cities = data.countries = null
                } else if (data.shipping_by === 'countries') {
                    data.zip_codes = data.cities = data.states = null
                } else if (data.shipping_by === 'no') {
                    data.zip_codes = data.cities = data.states = data.countries = data.esteric_zip = data.modifiedCodes = null
                }

                if (data.shipping_by !== "zip") {
                    data.zip_codes = null
                    data.esteric_zip = null
                    data.modifiedCodes = null
                }
                // if (data.charge_by !== "no") {
                //     data.default_cost = ''
                // }

                if (conditions.length < 2) {
                    for (const key in data.shipping_conditions) {
                        if (conditions.indexOf(key) < 0) {
                            const shipping_conditions = data.shipping_conditions
                            shipping_conditions[key] = null
                            data = { ...data, shipping_conditions: shipping_conditions }
                        }
                    }
                }
                loading(true)

                try {
                    if (!fetchJson) {
                        toast.content = "fetchJson is required"
                        throw new Error("fetchJson is required")
                    }
                    const responseData = await fetchJson(`/shipping`, {
                        method: rateId ? 'PUT' : 'POST',
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ data, "deletedRanges": DeletedRanges })
                    })
                    if (responseData.success) {
                        if (responseData.shippingData.length > 0) {
                            dispatch(saveShippingList(responseData.shippingData))
                        }
                    }
                    toast.error = !responseData.success
                    toast.content = responseData.message
                    if (navigate && !rateId) {
                        navigate('/rates')
                    }
                } catch (error) {
                    toast.content = error.message
                } finally {
                    loading(false)
                }
            } else {
                toast.content = "Some issues need to be fixed"
            }
        } else {
            toast.content = "Check Your Internet Connection."
        }
    } else {
        toast.content = "This feature is not available in current plan."
    }
    if (showToast) {
        dispatch(setToast({ ...toast }))
    }
}

